import React from 'react';
import PropTypes from 'prop-types';
import GravatarPic from 'core/components/GravatarPic';

import {
	AuthBox,
	Author,
	InfoCol,
	Stats,
	Stat,
	Label,
	Subscribed,
} from './authorSummaryStyles';

// Import icons by individual modules for better code splitting
import CameraSVG from 'core/icons/CameraSVG';
import StarFull from 'core/icons/StarFull';
import ThumbsUp from 'core/icons/ThumbsUp';

import { plural } from 'core/utils/stringUtils';

const AuthorSummary = ({
	name,
	id,
	email,
	totalHelpfulVotes,
	totalImages,
	totalReviews = 1,
	subscriptionLength,
	verified,
}) => (
	<AuthBox title={`See ${name}'s Reviewer Profile'`} href={`/reviewer/${id}/`}>
		<GravatarPic customerId={id} email={email} size={60} iconSize={55} />
		<InfoCol>
			<Author>{name}</Author>
			<Stats>
				<Stat>
					<StarFull />
					<Label>{totalReviews} {plural('Review', totalReviews)}</Label>
				</Stat>
				{totalImages > 0 && (
					<Stat>
						<CameraSVG />
						<Label>{totalImages} {plural('Picture', totalImages)}</Label>
					</Stat>
				)}
				{totalHelpfulVotes > 0 && (
					<Stat>
						<ThumbsUp />
						<Label>{totalHelpfulVotes} Helpful</Label>
					</Stat>
				)}
			</Stats>
			{verified && subscriptionLength && (
				<Subscribed>Subscribed for {subscriptionLength}</Subscribed>
			)}
		</InfoCol>
	</AuthBox>
);

AuthorSummary.propTypes = {
	name: PropTypes.string,
	id: PropTypes.number,
	email: PropTypes.string,
	totalHelpfulVotes: PropTypes.number,
	totalImages: PropTypes.number,
	totalReviews: PropTypes.number,
	subscriptionLength: PropTypes.string,
	verified: PropTypes.bool,
};

export default AuthorSummary;
